var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hococo-mobile-burger-menu",attrs:{"data-cy":_vm.$UI.Button.Mobile.Footer.BurgerMenu},on:{"click":_vm.showShelfMenu}},[_c('i',{staticClass:"fal fa-bars"})])}
var staticRenderFns = []

export { render, staticRenderFns }